import { createFileRoute } from '@tanstack/react-router';
import { ExpenditureNatureRouteComponent } from '@/app/route-components/settlement-statistics-converter/ExpenditureNatureRouteComponent';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';

/**
 * 決算統計コンバーター結果詳細ルート（マスタ - 歳出性質）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/master/expenditure_nature',
)({
  component: ExpenditureNatureRouteComponent,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
});
